import React from 'react';
import './Home.css';
import myPhoto from '../../images/my-photo.png';
import Particles from "react-tsparticles";
import reactIcon from '../../images/react.png';

const Home = () => {

        
    const particlesInit = (main) => {
        console.log(main);

    };
    
      const particlesLoaded = (container) => {
        console.log(container);
    };
    return (
        <>
            <div className='left__top'>
                <img src={reactIcon} alt="" />
            </div>
            <div className='right__top'>
                <img src={reactIcon} alt="" />
            </div>
            <div className='left__bottom'>
                <img src={reactIcon} alt="" />
            </div>
            <div className='right__bottom'>
                <img src={reactIcon} alt="" />
            </div>
            <Particles
                id="tsparticles"
                init={particlesInit}
                loaded={particlesLoaded}
                options={{
                    fpsLimit: 100,
                    interactivity: {
                    events: {
                        onClick: {
                        enable: true,
                        mode: "push",
                        },
                        onHover: {
                        enable: true,
                        mode: "repulse",
                        },
                        resize: true,
                    },
                    modes: {
                        bubble: {
                        distance: 100,
                        duration: 2,
                        opacity: 0.2,
                        size: 40,
                        },
                        push: {
                        quantity: 4,
                        },
                        repulse: {
                        distance: 100,
                        duration: 0.4,
                        },
                    },
                    },
                    particles: {
                    color: {
                        value: "#5770ff",
                    },
                    links: {
                        color: "#5770ff",
                        distance: 100,
                        enable: false,
                        opacity: 0.5,
                        width: 1,
                    },
                    collisions: {
                        enable: true,
                    },
                    move: {
                        direction: "none",
                        enable: true,
                        outMode: "bounce",
                        random: false,
                        speed: 2,
                        straight: false,
                    },
                    number: {
                        density: {
                        enable: true,
                        area: 800,
                        },
                        value: 30,
                    },
                    opacity: {
                        value: 0.5,
                    },
                    shape: {
                        type: "star",
                    },
                    size: {
                        random: true,
                        value: 6,
                    },
                    },
                    detectRetina: true,
                }}
            />
            <div className='home__section'>
            
                <div className='home__text'    data-aos="fade-down"
                    data-aos-easing="linear"
                    data-aos-duration="1500"
                >
                    <h1>Hi, <br /> I'm <span className="my-name">Naime Molla</span> From Bangladesh</h1>
                    <p>I'm a <span className="title-style">Front-end</span> web application developer</p>
                    <a href="https://drive.google.com/uc?export=download&id=1CpbtjzZmgyE63DTB_2SI3GhZDcCljsN1">
                        
                        <button className="resume-btn">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            
                            get resume <i className="fas fa-file-download"></i></button></a>
                </div>
                <div className='home__image' data-aos="fade-up"
                    data-aos-duration="2000"
                >
                    
                    <div className='my__image'>
                        <img src={myPhoto} alt="" />
                    </div>
                    
                </div>
            </div>
        </>
    );
};

export default Home;